import { FormHandles } from '@unform/core'

import { addAdComponents, AddAdProps } from './constants'

export const AddAd: React.FC<AddAdProps<FormHandles>> = ({
  adType,
  showEdit,
  formRef,
  queryParams,
  handleClickOnSave,
  handleClose
}) => {
  const Component = addAdComponents[adType]

  return (
    <div className="AddAdForm">
      <Component
        showEdit={showEdit}
        formRef={formRef}
        queryParams={queryParams}
        handleClickOnSave={handleClickOnSave}
        handleClose={handleClose}
      />
    </div>
  )
}
